export const FAILED_QR_CODE_REDIRECT_URL = '/checkout/finish?zpp=failed';
export const ACTION_CREATOR_PENDING_REDIRECT_URL =
  '/checkout/apppaymentrouterresult?status=pending&finishurl=/zpapp/checkout/finish?zpp=pending';
export const ACTION_CREATOR_FAILED_REDIRECT_URL =
  '/checkout/apppaymentrouterresult?status=pending&finishurl=/zpapp/checkout/finish?zpp=failed';

export const handleQrCodeFailureRedirect = () => {
  globalThis.location.replace(FAILED_QR_CODE_REDIRECT_URL);
};
export const handleActionCreatorFailureRedirect = () => {
  globalThis.location.replace(ACTION_CREATOR_FAILED_REDIRECT_URL);
};
export const handleActionCreatorPendingRedirect = () => {
  globalThis.location.replace(ACTION_CREATOR_PENDING_REDIRECT_URL);
};
